import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { useNavigate } from "react-router-dom";


const OrderNotConfirmed = () => {
    const adminUser = localStorage.getItem('adminUser')
    const [orders, setOrders] = useState([]);
    const navigate = useNavigate();
            
    
    useEffect(() => {
        if (!adminUser) {
                navigate("/login");
            }  


        fetch(`${process.env.REACT_APP_API_URL}/api/orders_not_confirmed/`)
          .then((res) => res.json())
          .then((data) => {
            setOrders(data)
          });
      }, []);


  return (
    <AdminLayout>
      <div>
        <h3 className="text-center text-primary mb-4">
          <i className="fas fa-list-alt me-1"></i>
          Details of Not Confirmed
        </h3>
        <h5 className="text-end text-muted">
          <i className="fas fa-database me-2"></i>
          Total Not Confirmed Orders
          <span className="ms-2 badge bg-danger">{orders.length}</span>
        </h5>


        <table className="table table-bordered table-hover table-striped">
          <thead className="table-dark">
            <tr>
              <th>Sl.No</th>
              <th>Order Number</th>
              <th>Order Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={order.id}>
                <td>{index+1}</td>
                <td>{order.order_number}</td>
                <td>{new Date(order.order_time).toLocaleString()}</td>
                <td>
                  <a href={`/admin-view-order-detail/${order.order_number}`} className="btn btn-sm btn-info me-2">
                    <i className="fas fa-info-circle me-1"></i>View Details
                  </a>
                  
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </AdminLayout>
  )
}

export default OrderNotConfirmed